import React from 'react'
import { FaFileAlt } from 'react-icons/fa'
import { getFileName } from '../../../utils/file/file'

const AdminSavedFileList = ({ savedFiles, onClickDeleteSavedFile, fileFolderName, isEdit }) => {
    return (
        <ul>
            {savedFiles.map((file, index) => {
                const fileName = getFileName(fileFolderName, file)
                return (
                    <li key={'savedFileItem' + index} className='file-list__item'>
                        <div className='file-list__filename'>
                            <a href={file} download={fileName} className='download-link'>
                                <FaFileAlt />&nbsp;{fileName}
                            </a>
                        </div>
                        {isEdit && (
                            <div className='file-list__button'>
                                <button type='button' className='btn btn-sm text-danger' onClick={() => onClickDeleteSavedFile(file)}>X</button>
                            </div>
                        )}
                    </li>
                )
            })}
        </ul>
    )
}

export default AdminSavedFileList